import React from "react";
import { Modal, Table, Button } from "react-bootstrap";
import { CrossView } from "../../../../../stores";
import { observer } from "mobx-react";

interface IProps {
    crosses: CrossView | null;
    onClose: () => void;
    deleteCross: (firstId: number, secondId: number) => void;
    isCrossDeleted: (firstId: number, secondId: number) => boolean;
}

@observer   
export class CrossesModal extends React.Component<IProps> {
    handleDeleteCross = (
        firstId: number,
        secondId: number,
        firstArticle: string,
        secondArticle: string
    ) => {

        if (window.confirm(
            `Вы точно хотите удалить связь ${firstArticle} и ${secondArticle}?`
        )) {
            this.props.deleteCross(firstId, secondId);
        }

    }

    isCrossDeleted = (
        firstId: number,
        secondId: number
    ) => {
        return this.props.isCrossDeleted(firstId, secondId);
    }

    render() {
        const { crosses } = this.props;

        if (!crosses) {
            return null;
        }

        const first = crosses.details[0];
        const second = crosses.details[1];

        return (
            <Modal
                show={true}
                onHide={this.props.onClose}
                size="lg"
                className="modal-xxl"
            >

                <Modal.Header closeButton>
                    <Modal.Title>
                        Редактирование кросс-связей
                    </Modal.Title>
                </Modal.Header>


                <Modal.Body>


                    <div className="alert alert-warning">
                        <strong>Внимание:</strong>
                        {" "}
                        Кросс-связь может быть не только прямой, но и рекурсивной.
                        Будьте внимательны при удалении связей.
                    </div>


                    {(crosses.hasSimple || crosses.complex.length > 0) &&
                        first &&
                        second &&
                        <Table
                            bordered
                            striped
                            hover
                            className="text-center"
                        >

                            <thead>
                                <tr>
                                    <th>
                                        Первая деталь
                                    </th>
                                    <th>
                                        Вторая деталь
                                    </th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr>
                                    <td>
                                        {first.brand}
                                        <br />
                                        {first.article}
                                    </td>

                                    <td>
                                        {second.brand}
                                        <br />
                                        {second.article}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {first.description}
                                    </td>

                                    <td>
                                        {second.description}
                                    </td>
                                </tr>

                            </tbody>

                        </Table>
                    }



                    {crosses.hasSimple &&
                        <Table
                            bordered
                            hover
                            className="text-center"
                        >

                            <thead>
                                <tr>
                                    <th colSpan={3}>
                                        Прямой кросс:
                                    </th>
                                </tr>
                            </thead>


                            <tbody>

                                <tr>

                                    <td>
                                        {first.brand}
                                        <br />
                                        {first.article}
                                    </td>


                                    <td>
                                        =
                                        <br />

                                        {
                                            this.isCrossDeleted(first.id, second.id) ?

                                                <span>
                                                    Связь удалена
                                                </span>

                                                :

                                                <Button
                                                    variant="link"
                                                    onClick={() =>
                                                        this.handleDeleteCross(
                                                            first.id,
                                                            second.id,
                                                            first.article,
                                                            second.article
                                                        )
                                                    }
                                                >
                                                    Удалить связь
                                                </Button>
                                        }

                                    </td>


                                    <td>
                                        {second.brand}
                                        <br />
                                        {second.article}
                                    </td>

                                </tr>

                            </tbody>

                        </Table>
                    }



                    {crosses.complex.length > 0 &&

                        <Table
                            bordered
                            hover
                            className="text-center"
                        >

                            <thead>
                                <tr>
                                    <th colSpan={5}>
                                        Составные кроссы:
                                    </th>
                                </tr>
                            </thead>


                            <tbody>


                                {crosses.complex.map(cross =>

                                    <tr key={cross.id}>


                                        <td>
                                            {first.brand}
                                            <br />
                                            {first.article}
                                            <br />
                                            {first.description}
                                        </td>


                                        <td>

                                            =
                                            <br />

                                            {
                                                this.isCrossDeleted(first.id, cross.id) ?

                                                    <span>
                                                        Связь удалена
                                                    </span>

                                                    :

                                                    <Button
                                                        variant="link"
                                                        onClick={() =>
                                                            this.handleDeleteCross(
                                                                first.id,
                                                                cross.id,
                                                                first.article,
                                                                cross.article
                                                            )
                                                        }
                                                    >
                                                        Удалить связь
                                                    </Button>
                                            }

                                        </td>


                                        <td>
                                            {cross.brand}
                                            <br />
                                            {cross.article}
                                            <br />
                                            {cross.description}
                                        </td>


                                        <td>

                                            =
                                            <br />

                                            {
                                                this.isCrossDeleted(second.id, cross.id) ?

                                                    <span>
                                                        Связь удалена
                                                    </span>

                                                    :

                                                    <Button
                                                        variant="link"
                                                        onClick={() =>
                                                            this.handleDeleteCross(
                                                                second.id,
                                                                cross.id,
                                                                second.article,
                                                                cross.article
                                                            )
                                                        }
                                                    >
                                                        Удалить связь
                                                    </Button>
                                            }

                                        </td>


                                        <td>
                                            {second.brand}
                                            <br />
                                            {second.article}
                                            <br />
                                            {second.description}
                                        </td>


                                    </tr>

                                )}

                            </tbody>

                        </Table>

                    }


                </Modal.Body>

            </Modal>
        );
    }
}